import { IEmployee, ShiftService, IShift } from "../../../services/index";
import * as _ from "lodash";
import * as moment from "moment";
interface IResolve {
    employee: IEmployee;
    shifts: IShift[];
}

class ShiftsItemController {

    private resolve: IResolve;
    private employee: IEmployee;
    private shift: IShift;

    constructor(
        private ShiftService: ShiftService,
        private $state: ng.ui.IStateService,
        private $stateParams: ng.ui.IStateParamsService
    ) {
        'ngInject';
    }

    public $onInit = () => {
        this.employee = this.resolve.employee;
        var shiftId : string = this.$stateParams['shiftId'];
        if (shiftId != '') {
            this.shift = <IShift>_.find(<any>this.resolve.shifts, { "id": shiftId });
        } else {
            this.shift = new IShift();
        }
    }

    startDateBeforeRender($dates) {
        // console.log('startDateBeforeRender');
        const todaySinceMidnight = new Date();
        todaySinceMidnight.setUTCHours(0,0,0,0);
        // $dates.filter(function (date) {
        //     return date.utcDateValue < todaySinceMidnight.getTime();
        // }).forEach(function (date) {
        //     date.selectable = false;
        // });
    }

    endDateBeforeRender($view, $dates) {
        // console.log('endDateBeforeRender');
        if (this.shift.start) {
            var activeDate = moment(this.shift.start).subtract(1, $view).add(1, 'minute');

            $dates.filter(function (date) {
                return date.localDateValue() <= activeDate.valueOf();
            }).forEach(function (date) {
                date.selectable = false;
            });
        }
    }

    public submitShift() {
        this.shift.start = moment(this.shift.start).format("YYYY-MM-DD HH:mm");
        this.shift.end = moment(this.shift.end).format("YYYY-MM-DD HH:mm");
        if (this.shift.id === undefined) {
            this.shift.employeeId = this.employee.id;
            this.ShiftService.post(this.shift).then((data) => {
                this.closeModal();
            });
        } else {
            this.ShiftService.put(this.shift.id, this.shift).then((data) => {
                this.closeModal();
            });
        }
    }

    delete() {
        this.ShiftService.delete(this.shift.id).then((data) => {
            this.closeModal();
        });
    }

    private closeModal() {
        this.$state.go('^', {tab: 0}, {reload: true});
    }
}

export const shiftsItemComponent = { 
    bindings: {
        resolve : "<",
        close: "&"
    },
    controller: ShiftsItemController,
    template: require('./shifts.item.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/hr/shifts/shifts.item.component.ts